exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-sm-38pr{\n    width: 38% !important;\n}\n.col-sm-54pr{\n    width: 54.60% !important;\n}\n.table-null,\n.table-null td,\n.table-null th{\n  border: 0px !important;\n  margin: 0px !important;\n  padding: 0px !important;\n}\n.table-null button.btn{\n  padding: 6px 5px !important;\n}\n.card-button{\n  height:170px;\n  width: 100%;\n  margin-bottom:5px;\n  border: 1px solid #DDD;\n  background-color: #FFF;\n  font-size: 13px !important;\n  padding: 0px !important;\n}\n.card-button:disabled{\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.card-button:focus,.card-button:active{\n  background-color: #CCC !important;\n}\n.card-button-danger{\n  border: 1px solid #f3cf6c !important;\n  background-color: #ffe8a6 !important;\n}\n.card-button-danger:focus,.card-button-danger:active{\n  background-color: #f3d37a !important;\n}\n.card-button-success{\n  border: 1px solid #6cf382 !important;\n  background-color: #caffa6 !important;\n}\n.card-button-success:focus,.card-button-success:active{\n  background-color: #6df183 !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/ventas/punto-venta-tactil-add/punto-venta-tactil-add.component.css
// module id = ../../../../../src/app/components/ventas/punto-venta-tactil-add/punto-venta-tactil-add.component.css
// module chunks = main